$.fn.leftSlideBanner = function () {
  const $this = this;

  this.open = function () {
    this.css("left", "-1000px");
    this.css("display", "block");
    this.animate({ left: 0 }, 1000);
  };

  this.close = function () {
    this.animate({ left: "-1000px" }, 1000, () => {
      $this.css("display", "none");
    });
  };

  this.find(".left-slide-banner-close").on("click", function () {
    $this.close();
  });

  return this;
};
